<template>
  <div class="login-wrapper">
    <div class="info">
      <h1 class="info-list-item">TRUMPETTI</h1>
      <ul class="info-list">
        <li class="info-list-item">
          {{ $t("login.info1") }}
        </li>
        <li class="info-list-item">
          {{ $t("login.info2") }}
        </li>
        <li class="info-list-item">
          {{ $t("login.info3") }}
        </li>
      </ul>
      <i style="font-size: 100px" class="fa fa-envelope" aria-hidden="true"></i>
    </div>
    <div class="login-window bg-paper-elevation-0">
      <div class="login">
        <div class="row mb-2">
          <h3 class="col">{{ $t("login.login") }}</h3>
        </div>
        <div class="col">
          <div class="form-group">
            <label class="form-label">{{ $t("login.username") }}</label>
            <input
              @keyup.enter="submit"
              type="email"
              name="username"
              autocomplete="username"
              data-id="login.username"
              class="form-control"
              :placeholder="$t('login.username')"
              v-model="username"
            />
          </div>
          <div class="form-group">
            <label class="form-label">{{ $t("login.password") }}</label>
            <input
              @keyup.enter="submit"
              type="password"
              name="password"
              autocomplete="on"
              class="form-control"
              :placeholder="$t('login.password')"
              v-model="password"
            />
          </div>
          <button
            data-id="login.submit"
            class="col btn btn-primary"
            @click="submit"
          >
            {{ $t("login.login") }}
          </button>
          <div class="row mt-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
    };
  },
  beforeRouteEnter(to, from, next) {
    document.body.classList.add("gradient-bg");
    next();
  },
  beforeRouteLeave(to, from, next) {
    document.body.classList.remove("gradient-bg");
    next();
  },
  methods: {
    submit: async function () {
      try {
        let res = await this.$store.dispatch("login", {
          name: this.username,
          pass: this.password,
        });
        if (res) {
          this.$router.push({ name: "suppliers" });
          this.$store.dispatch("listContract", this.$store.getters.userData);
        }
      } catch (error) {
        this.$notify({
          type: "error",
          text: this.$t(error),
          duration: 1000,
        });
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  margin: 10% auto 0 auto;
  max-width: 1200px;
}
.login-window {
  border-radius: 15px;
  color: #212529;
  float: right;
  padding: 1em;
  height: 600px;
  /* margin: 15% auto; */
  width: 420px;
}
.info {
  text-align: left;
  position: relative;
  float: left;
  padding: 1em 1em 1em 2em;
  height: 600px;
  /* margin: 15% auto; */
  max-width: 540px;
}
.info > .fa-envelope {
  position: absolute;
  bottom: 0px;
  left: 40%;
  color: #FFFFFF;
}

.info-list {
  list-style: disc;
  padding: 0;
  color: #FFFFFF;
}
.info-list-item {
  font-size: 25px;
  font-weight: bold;
  margin: 20px 0 20px 0;
  color: #FFFFFF;
}
.alert-danger {
  padding: 0.5em;
  border-radius: 0;
  color: #721c24;
  /*   background-color: #f8d7da;*/
  border-color: #f5c6cb;
  background-color: rgba(229, 77, 66, 0.623);
  border-color: #b82e24;
}

.alert-success {
  color: #155724;
  background-color: #a1d39f;
  border-color: #73b171;
  border-radius: 0;
}
.form-group {
  margin-right: 0;
}
.form-control:focus {
  border: 1px solid #086A91;
  box-shadow: 0 0 5px #086A91;
}
@media screen and (max-width: 768px) {
  .login-wrapper {
    display: flex;
    flex-direction: column;
  }
  .login-window {
    float: none;
    margin: auto;
  }
  .info {
    float: none;
    margin: auto;
    height: auto;
  }
  .info > .fa-envelope {
    display: none;
  }
  .info-list-item {
    font-size: 1.5rem;
  }
}

@media screen and (max-width: 425px) {
  .login-window {
    width: 100%;
    height: auto;
  }
  .info {
    padding: 0 0 0 1em;
  }
}
</style>